import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

// SERVICES
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderApiService {
  private readonly _submittingForm = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  submittingForm$ = this._submittingForm.asObservable();
  loading$ = this._loading.asObservable();

  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  updateLineItems(data :any) :Observable<any> {
    const { items } = data;
    this._submittingForm.next(true);
    this._loading.next(true);

    return this.apiService
      .post({
        path: `${this.environment.urlV2}/purchase-orders/line-item/bulk-update`,
        body: {
          items,
        },
      })
      .pipe(
        map((response :any) => {
          this._submittingForm.next(false);
          this._loading.next(false);

          return response;
        }),
        catchError((response) => {
          this._submittingForm.next(false);
          this._loading.next(false);

          return throwError(() => response.error);
        }),
      );
  }

  getSupplierPurchaseOrdersV1(params ?:{ [key :string] :any }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV1}/mt_purchase_orders`, {
      params: params,
    });
  }

  createByOrderLineItems(salesOrderItemIds :number[]) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/orders/supplier-purchases/auto-create-from-sales-order-items`,
      body: { salesOrderItemIds },
    });
  }

  exportSupplierPurchaseOrder(
    purchaseOrderId :number,
    params :{
      [key :string] :string | string[];
    },
  ) :Observable<any> {
    return this.apiService.getBlob(
      `${this.environment.urlV2}/purchase-orders/export/${purchaseOrderId}`,
      {
        params: params,
      },
    );
  }
}
